var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.579449 0.408203C0.42583 0.408338 0.278406 0.46938 0.169657 0.577995C0.0610464 0.68674 0 0.834164 0 0.987787V11.4197C0 11.5734 0.061043 11.7208 0.169657 11.8295C0.278403 11.9381 0.425826 11.9992 0.579449 11.9992H16.4206C16.5742 11.9992 16.7216 11.9381 16.8303 11.8295C16.939 11.7208 17 11.5734 17 11.4197V0.987787C17 0.834167 16.939 0.686744 16.8303 0.577995C16.7216 0.469384 16.5742 0.408338 16.4206 0.408203H0.579449ZM2.22158 1.56738H14.7786L8.50007 6.62018L2.22158 1.56738ZM1.15904 2.19519L8.13782 7.80961C8.24063 7.89194 8.36838 7.93681 8.50004 7.93681C8.63169 7.93681 8.75944 7.89194 8.86226 7.80961L15.841 2.19519V10.8402H1.15904V2.19519Z",
    fill: "#8A8E96"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconGrey);
export default __webpack_public_path__ + "static/media/email-icon-grey.6e4c3710f2fab1535a79d8d609b891bc.svg";
export { ForwardRef as ReactComponent };